;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();import "./mega-menu.scss";
import Container from "@/components/Container";
import {CMSLink} from "@/components/Link";

interface MegaMenuProps {
	links: any;
	isOpen: boolean;
	closeMenu: () => void;
	top: number;
	onMouseEnter: () => void;
	onMouseLeave: () => void;
}

export default function MegaMenu({
	links,
	isOpen,
	closeMenu,
	top,
	onMouseEnter,
	onMouseLeave,
}: MegaMenuProps) {
	if (!links || links.length === 0) return null;

	return (
		// biome-ignore lint/a11y/noStaticElementInteractions: <explanation>
		<div
			className={`mega-menu ${isOpen ? "mega-menu--open" : ""}`}
			style={{ top: `${top}px` }}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
		>
			<Container>
				<div className="mega-menu__grid">
					{links.map((column: any) => (
						<div key={column.id} className="mega-menu__column">
							{column.links?.map(({ link }: { link: any }, index: number) => (
								// biome-ignore lint/a11y/noStaticElementInteractions: <explanation>
								<div
									key={link.id || index}
									className={`mega-menu__item ${index === 0 ? "mega-menu__item--heading" : ""}`}
									onClick={closeMenu}
									onKeyDown={(e) => e.key === "Enter" && closeMenu()}
								>
									<CMSLink {...link} appearance="inline" />
								</div>
							))}
						</div>
					))}
				</div>
			</Container>
		</div>
	);
}
